import { Menu } from "lucide-react";
import ThemeToggle from "@ui/ThemeToggle";

/**
 * Persistent app-level top header. Hosts hamburger (mobile) and theme toggle.
 * Chat is now a floating FAB (ChatFAB) so it's accessible on all pages
 * without occupying header space.
 */
export default function TopBar({ onOpenMenu }) {
  return (
    <header
      className="sticky top-0 z-40 flex items-center gap-2 px-3 py-2 backdrop-blur-md"
      style={{
        height: "var(--topbar-h)",
        background: "color-mix(in srgb, var(--bg-root) 80%, transparent)",
        borderBottom: "1px solid var(--border-card-base)",
      }}
    >
      <button
        type="button"
        onClick={onOpenMenu}
        className="hidden p-2 rounded-lg transition-colors hover:bg-white/[0.05]"
        style={{
          background: "var(--bg-input)",
          border: "1px solid var(--border-input)",
        }}
        aria-label="Open menu"
      >
        <Menu className="w-4 h-4" style={{ color: "var(--text-heading)" }} />
      </button>
      <div className="flex-1" />
      <ThemeToggle />
    </header>
  );
}
